import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { ClipPath, Defs, G, Path, Rect } from "react-native-svg";

export const IconTorch: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTorch"><G ClipPath="url(#clip0_15368_27803)"><Path d="M10.25 5.25L18.75 13.75" stroke="currentColor"/><Path d="M1.5 16.725L8.85 9.375L9.375 5.7L13.575 1.5L22.5 10.425L18.3 14.625L14.625 15.15L7.275 22.5L1.5 16.725Z" stroke="currentColor" strokeWidth="1.05"/><Path d="M9.5 14.5L12 12" stroke="currentColor"/></G><Defs><ClipPath id="clip0_15368_27803"><Rect width="24" height="24" fill="white"/></ClipPath></Defs></CentralIconBase>;
});

export default IconTorch;
